import React from "react";
import { useNavigate } from 'react-router-dom';
import axios from "../../../../../axios";
import "./pendingStudentpopup.css";
// all css comes in successfullActivity.css
const PendingStudentPopup = ({ setPendingPopup, reviewActivity_id }) => {
  const navigate = useNavigate();
  const handleStatus = async (e) => {
    // console.log("click");
    e.preventDefault();
    let changeStatus = {
      status: "completed",
    };
    try {
      const res = await axios.post(
        `/api/v1/homework/activity/updateStatus/${reviewActivity_id}`,
        changeStatus
      );
      // console.log("res", res);

      res && navigate("/PublishedHomeworkActivity");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className=" successful_preview_transprant_body ">
        <div className=" p-2 successful_preview_container_on_review_box shadow">
          {/* <img src="/images/pending_icon.svg" alt="" /> */}
          <span className=" my-4 successfully_message">
            There are some students who haven't submitted the Activity, do you
            still want to publish the result?
          </span>
          <div>
            {/* <button
              className="successfull_okay_btn"
              onClick={(e) => setPendingPopup(false)}
            >
              Go Back
            </button> */}
            <button
              className="btn me-3 py-2  goBack_btn"
              onClick={(e) => setPendingPopup(false)}
            >
              Go Back
            </button>
            {/* <button
              className="successfull_okay_btn"
              onClick={(e) => handleStatus(e)}
            >
              Continue
            </button> */}
            <button
              className="btn   m-1 py-2 Next_button_publicAct"
              onClick={(e) => handleStatus(e)}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingStudentPopup;
